__turbopack_context__.v({
  "flagIcon": "zaQHFq_flagIcon",
  "footer": "zaQHFq_footer",
  "footerBrandLink": "zaQHFq_footerBrandLink",
  "footerCategoriesColumn": "zaQHFq_footerCategoriesColumn",
  "footerCategoriesList": "zaQHFq_footerCategoriesList",
  "footerCategoryMain": "zaQHFq_footerCategoryMain",
  "footerColumnList": "zaQHFq_footerColumnList",
  "footerColumnTitle": "zaQHFq_footerColumnTitle",
  "footerDivider": "zaQHFq_footerDivider",
  "footerGrid": "zaQHFq_footerGrid",
  "footerLangActive": "zaQHFq_footerLangActive",
  "footerLangLink": "zaQHFq_footerLangLink",
  "footerLanguageButtonsRow": "zaQHFq_footerLanguageButtonsRow",
  "footerLanguageMenu": "zaQHFq_footerLanguageMenu",
  "footerLanguageSelectLabel": "zaQHFq_footerLanguageSelectLabel",
  "footerLanguageSelectTrigger": "zaQHFq_footerLanguageSelectTrigger",
  "footerLanguageWrap": "zaQHFq_footerLanguageWrap",
  "footerLegal": "zaQHFq_footerLegal",
  "footerSocial": "zaQHFq_footerSocial",
  "footerSubList": "zaQHFq_footerSubList",
  "hamburgerBox": "zaQHFq_hamburgerBox",
  "hamburgerBtn": "zaQHFq_hamburgerBtn",
  "hamburgerLine": "zaQHFq_hamburgerLine",
  "hamburgerLineBottomOpen": "zaQHFq_hamburgerLineBottomOpen",
  "hamburgerLineMidOpen": "zaQHFq_hamburgerLineMidOpen",
  "hamburgerLineTopOpen": "zaQHFq_hamburgerLineTopOpen",
  "languageButton": "zaQHFq_languageButton",
  "languageButtonActive": "zaQHFq_languageButtonActive",
  "languageButtonsRow": "zaQHFq_languageButtonsRow",
  "languageLabel": "zaQHFq_languageLabel",
  "languageMenu": "zaQHFq_languageMenu",
  "languageMenuItem": "zaQHFq_languageMenuItem",
  "languageMenuItemActive": "zaQHFq_languageMenuItemActive",
  "languageSelectChevron": "zaQHFq_languageSelectChevron",
  "languageSelectLabel": "zaQHFq_languageSelectLabel",
  "languageSelectTrigger": "zaQHFq_languageSelectTrigger",
  "languageSwitcher": "zaQHFq_languageSwitcher",
  "logoLink": "zaQHFq_logoLink",
  "mobileNavCloseBtn": "zaQHFq_mobileNavCloseBtn",
  "mobileNavHeader": "zaQHFq_mobileNavHeader",
  "mobileNavLink": "zaQHFq_mobileNavLink",
  "mobileNavLinkActive": "zaQHFq_mobileNavLinkActive",
  "mobileNavLinks": "zaQHFq_mobileNavLinks",
  "mobileNavOverlay": "zaQHFq_mobileNavOverlay",
  "mobileNavPanel": "zaQHFq_mobileNavPanel",
  "mobileNavPanelOpen": "zaQHFq_mobileNavPanelOpen",
  "navActions": "zaQHFq_navActions",
  "navLink": "zaQHFq_navLink",
  "navLinkActive": "zaQHFq_navLinkActive",
  "navMenu": "zaQHFq_navMenu",
  "navbar": "zaQHFq_navbar",
  "searchBtn": "zaQHFq_searchBtn",
  "searchForm": "zaQHFq_searchForm",
  "searchInput": "zaQHFq_searchInput",
  "srOnly": "zaQHFq_srOnly",
  "topBar": "zaQHFq_topBar",
  "topBarHomeLink": "zaQHFq_topBarHomeLink",
  "topBarLanguagesLabel": "zaQHFq_topBarLanguagesLabel",
  "wrapper": "zaQHFq_wrapper",
});
